// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"910cd486","897":"910cd486"}[chunkId] + ".chunk.css";
};